import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ALAIN_I18N_TOKEN } from '@delon/theme';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { RebirthHttp } from 'rebirth-http';
import { forkJoin,BehaviorSubject } from 'rxjs';
import { I18NService } from './i18n.service';
import * as _ from 'lodash';
import { EnvironmentService } from '../../services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class I18nClientService extends RebirthHttp {

  commonResourceLoaded$ = new BehaviorSubject<boolean>(false);
  files: string[] = ['/default.json', '/common.json', '/rdm.json', '/bps.json', '/menu.json', '/sez.json', '/sez-admin.json', '/um.json', '/ics.json',
    '/gsf.json', '/gsf-studio.json',
    '/ums/base.json', '/ums/errors.json', '/ums/messages.json', '/ums/response.json',
    '/lpco/errors.json', '/lpco/messages.json',
    '/ics/base.json', '/ics/errors.json', '/ics/messages.json', '/ics/response.json', '/tooltip/common.json'];
  envValue:any = [];
  constructor(public override  http: HttpClient,
    private translate: TranslateService,
    private titleService: Title,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    private envs: EnvironmentService) {
    super(http);
  }

  loadResource(lang?: any) {
    let loadEnResource = false;
    if(_.isEmpty(lang)){
      lang = this.i18n.defaultLang;
      loadEnResource = !(lang==='en-US');
    }
    this.envValue = this.envs.getEnvironment();
    this.i18n.setLanguages();
    const path = this.i18n.getLangResource(lang);
    const resourceRequest:any = [];
    let langData = {};

    this.files.forEach(f => {
      resourceRequest.push(this.http.get(this.envValue.baseUrl +
        (!_.isEmpty(this.envValue.assetsEndPoint) ? this.envValue.assetsEndPoint : '') + '/assets/i18n/' + path + f));
    });

    this.http.get(this.envValue.baseUrl +
      (!_.isEmpty(this.envValue.assetsEndPoint) ? this.envValue.assetsEndPoint : '') + '/assets/i18n/' + path + '/common.json').subscribe((result) => {
      this.translate.setTranslation(_.isEmpty(lang) ? this.i18n.defaultLang : lang, result, true);
      this.translate.use(lang);
      this.commonResourceLoaded$.next(true);
    });
    forkJoin(resourceRequest).subscribe((result:any) => {
      result.forEach((r:any) => {
        langData = _.merge(r, langData);
      });
      this.translate.setTranslation(_.isEmpty(lang) ? this.i18n.defaultLang : lang, langData);
      this.translate.use(lang);
      this.titleService.setTitle(this.translate.instant(this.envValue.appTitle));
    });
    if(loadEnResource){
      const enResourceRequest:any = [];
      this.files.forEach(f => {
        enResourceRequest.push(this.http.get(this.envValue.baseUrl +
          (!_.isEmpty(this.envValue.assetsEndPoint) ? this.envValue.assetsEndPoint : '') + '/assets/i18n/en' + f));
      });
      forkJoin(enResourceRequest).subscribe((result:any) => {
        result.forEach((r: any) => {
          langData = _.merge(r, langData);
        });
        this.translate.setTranslation(_.isEmpty(lang) ? this.i18n.defaultLang : lang, langData);
      });
    }
  }

  isCommonResourceLoaded() {
    return this.commonResourceLoaded$;
  }

  translateErrMsg(errMsg: string | string[]) {
    let msg = '';
    if (Array.isArray(errMsg)) {
      for (let i = 0; i < errMsg.length; i++) {
        const msgKey = errMsg[i].replace('{', '').replace('}', '');
        if (msg) msg += '\n';
        msg += this.translate.instant(msgKey);
      }
    } else {
      const msgKey = errMsg.replace('{', '').replace('}', '');
      msg = this.translate.instant(msgKey);
    }
    return msg;
  }
}
